import 'quasar/dist/quasar.css'
import '@quasar/extras/material-icons/material-icons.css'

import { createApp } from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import Loading from 'quasar/src/plugins/loading/Loading.js';;
import { createPinia } from 'pinia';

import PageComponent from './IntegrationsHubspot.vue';

import api from '@services/api.js';
import EventHub from '@util/EventHub.js';
import esignBrand from '@theme/esignBrand.js';

const app = createApp(PageComponent);

const pinia = createPinia();
app.use(pinia);

app.use(Quasar, {
    plugins: { Notify, Dialog, Loading },
    config: {
        brand: esignBrand,
        notify: { position: 'top-right', timeout: 3000 },
        loading: { delay: 400 }
    }
});

app.config.globalProperties.$api = api;
app.config.globalProperties.$eventHub = EventHub;
app.provide('api', api);
app.provide('eventHub', EventHub);

app.mount('#q-app');
window._esignApp = app;
